<template>
  <div style="margin-top: 40px;margin-bottom: 40px;">
    <h3 class="index-title">{{ title }}</h3>
    <p class="index-desc">{{ desc }}</p>
  </div>
</template>

<script>
export default {
  name: "TitleDesc",
  props: {
    title: String,
    desc: String,
  }
}
</script>

<style scoped lang="scss">
.index-title {
  font-size: 32px;
  font-weight: 500;
  color: #333333;
}
.index-desc {
  font-size: 18px;;
  font-weight: 400;
  color: #545454;
  margin-top: 10px;
}
</style>
